import { Outlet } from '@/core/entity';
import {
  IOutletGateway,
  OutletInput,
  PresenterFunc,
  UpdaterFunc,
} from '@/core/interface';
import { CreateOutlet, UpdateOutlet } from '@/core/usecase';

export class OutletController {
  constructor(
    private readonly outletGw: IOutletGateway,
  ) { }

  public create(
    input: OutletInput,
    presenter: PresenterFunc<Outlet | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new CreateOutlet(this.outletGw);

    useCase.execute(input, presenter, updater);
  }

  public update(
    id: string,
    input: OutletInput,
    presenter: PresenterFunc<Outlet | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new UpdateOutlet(this.outletGw);

    useCase.execute(id, input, presenter, updater);
  }
}
